mutation verifyPassword($password: String!) {
  verifyPassword(password: $password) {
    verified
  }
}
